import React, { Component } from 'react';

import Configs from 'Configuration';
import FhtFetchUrl from 'Utils/FhtFetchUrl.jsx';

import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';

import SnackbarContentWrapper from 'components/SnackbarContentWrapper';

class LinkmeAppointmentEligibility extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appointmentQueryInterval: "",
      appointmentEligibilityDays: "",
      appointmentReminderDays: ""
    };

    this.getSmsSettings();
  }

  render() {
    return (
      <Box maxWidth={800} margin="auto">
        {this.renderSnackbar()}
        <Typography variant="h3" gutterBottom>Appointment Eligibility & Intervals</Typography>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom>Appointment Query Interval</Typography>
                <Typography variant="subtitle1">How often Linkme+ queries the appointment booking table</Typography>
                <TextField
                  fullWidth
                  type="number"
                  variant="outlined"
                  label="Query Interval"
                  value={this.state.appointmentQueryInterval}
                  onChange={(e) => this.setState({ appointmentQueryInterval: e.target.value })}
                  helperText="Minutes between queries"
                  margin="normal"
                />
              </Box>
            </Paper>
          </Grid>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom>Appointment Linkme+ Eligibility</Typography>
                <Typography variant="subtitle1">The number of days from today for an appointment to be eligible</Typography>
                <TextField
                  fullWidth
                  type="number"
                  variant="outlined"
                  label="Appointment Elibility"
                  value={this.state.appointmentEligibilityDays}
                  onChange={(e) => this.setState({ appointmentEligibilityDays: e.target.value })}
                  helperText="Days an appointment is eligible"
                  margin="normal"
                />
              </Box>
            </Paper>
          </Grid>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom>SMS Reminder</Typography>
                <Typography variant="subtitle1">The number of days <i>before</i> an appointment</Typography>
                <TextField
                  fullWidth
                  type="number"
                  variant="outlined"
                  label="Appointment Reminder"
                  //value={this.state.appointmentReminderDays}
                  //onChange={(e) => this.setState({ appointmentReminderDays: e.target.value })}
                  value={this.state.appointmentReminderDays ?? 1}
                  onChange={(e) => {
                    let value = Number(e.target.value);
                    value = Math.max(0, Math.min(3, value)); // Restrict between 0 and 3
                    this.setState({ appointmentReminderDays: value });
                  }}
                  helperText="Days before an appointment to send a reminder"
                  margin="normal"
                />
              </Box>
            </Paper>
          </Grid>
          <Grid container spacing={1} justifyContent="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.setSmsSettings()}>
                {this.state.settingsIsSaving ? <CircularProgress color="inherit" size={20} /> : "Save"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }

  renderSnackbar() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={this.state.openSnackbar}
        autoHideDuration={4000}
        onClose={() => this.setState({ openSnackbar: false })}
      >
        <SnackbarContentWrapper
          onClose={() => this.setState({ openSnackbar: false })}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
        />
      </Snackbar>
    );
  }

  async getSmsSettings() {
    try {
      const api = FhtFetchUrl(Configs.getSmsSettings);
      const response = await api.post(["AppointmentScanFrequencyMinutes", "AppointmentEligibleDays", "ResendSMSReminderDays"]);
      const appointmentQueryInterval = response["AppointmentScanFrequencyMinutes"];
      const appointmentEligibilityDays = response["AppointmentEligibleDays"];
      const appointmentReminderDays = response["ResendSMSReminderDays"];
      this.setState({
        appointmentQueryInterval,
        appointmentEligibilityDays,
        appointmentReminderDays
      });
    }
    catch (e) {
      this.setState({ snackbarMessage: "Could get SMS settings", snackbarVariant: "error", openSnackbar: true });
    }
  }

  async setSmsSettings() {
    try {
      const api = FhtFetchUrl(Configs.setSmsSettings);
      this.setState({ settingsIsSaving: true });
      await api.post({
        "AppointmentScanFrequencyMinutes": this.state.appointmentQueryInterval,
        "AppointmentEligibleDays": this.state.appointmentEligibilityDays,
        "ResendSMSReminderDays": this.state.appointmentReminderDays,
      });

      this.setState({ snackbarMessage: "Settings saved successfully", snackbarVariant: "success", openSnackbar: true });
    }
    catch (e) {
      this.setState({ snackbarMessage: "Could not save SMS settings", snackbarVariant: "error", openSnackbar: true });
    }
    finally {
      this.setState({ settingsIsSaving: false });
    }
  }
}

export default LinkmeAppointmentEligibility;
